import axios from 'axios';
import { attachSentryErrorReporting } from '@getin-widgets/sentry';
import Cookies from 'js-cookie';
import { GET_IN_AUTH_TOKEN_COOKIE_KEY } from '~/utils/constants';
import ICustomAxiosRequestConfig from './custom/ICustomAxiosRequestConfig';

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

api.interceptors.request.use(async (config: ICustomAxiosRequestConfig) => {
  const token =
    Cookies.get(GET_IN_AUTH_TOKEN_COOKIE_KEY) === 'undefined'
      ? ''
      : Cookies.get(GET_IN_AUTH_TOKEN_COOKIE_KEY);

  if (config.headers && token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  if (config.headers && config.serverSide) {
    config.headers['GI-BYPS-RL'] = `${process.env.NEXT_PUBLIC_HEADER_KEY}`;
  }

  return config;
});

attachSentryErrorReporting(api);
